import { Component, AfterViewInit } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { Observable } from 'rxjs';
import { JobReferenceService } from '../job-reference.service';
import { JobReference } from '../job-reference';
import { GridApi, ICellEditorParams } from 'ag-grid-community';
import { TicketService } from '../../../tickets/ticket.service';

@Component({
  selector: 'job-reference-cell',
  templateUrl: './job-reference-cell.component.html',
  styleUrls: ['./job-reference-cell.component.scss'],
  providers: [TicketService],
})
export class JobReferenceCellComponent implements ICellEditorAngularComp, AfterViewInit {
  params!: ICellEditorParams;
  gridApi!: GridApi;
  reference!: JobReference;

  value = '';

  constructor(private ticketService: TicketService) { }

  agInit(params: ICellEditorParams) {
    this.params = params;
    this.gridApi = params.api;
  }

  ngAfterViewInit(): void { }

  getValue() {
    if (this.reference) {
      return this.reference.jobName;
    }

    const cell = this.gridApi.getFocusedCell();
    const row = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);

    return row && row.data.jobName ? row.data.jobName : '';
  }

  isCancelBeforeStart?(): boolean {
    return false;
  }

  isCancelAfterEnd?(): boolean {
    return false;
  }

  isPopup() {
    return true;
  }

  onReferenceClicked(reference: JobReference): void {
    const cell = this.gridApi.getFocusedCell();
    const row = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);

    this.ticketService.updateFieldReference<JobReference>(row.data.id, reference, 'job').subscribe(ticket => {
      this.reference = reference;

      row.setData(ticket);

      this.gridApi.stopEditing();
    });
  }

  onReferenceClosed(): void {
    this.gridApi.stopEditing();
  }
}
